import React from "react";

class Bottom extends React.Component {
  render() {
    return (
      <nav className="navbar fixed-bottom navbar-light bg-light" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
        <span className="navbar-text">&copy; {process.env.REACT_APP_MODE}</span>
      </nav>
    );
  }
}

export default Bottom;
